import { ENV } from '@app-bootstrap/environment.bootstrap'

export const settingsForColijn3DViewer = {
    assetPath: 'https://cdn.ione360.com/content43/',
    threeDAssetPath: 'https://cdn.ione360.com/content380',
    assetIndex: 'index-white.json',
    currencySymbol: '€',
    useWebsocket: false,
    options: {
        useStandaloneFloors: true,
        showAsConfigured: true,
        showMeasurementsButton: true,
        arEnabled: false,
        showStandaloneARButton: true,
    },
}
export const colijnConfigProduction = {
    ...settingsForColijn3DViewer,
    url: 'https://eekhoorn.ionecloud.nl/ione/',
    ajaxUrl: 'https://eekhoorn.ionecloud.nl/ione/',
    schema: '67324',
    version: '251',
}

export const colijnConfigStaging = {
    ...settingsForColijn3DViewer,
    url: 'https://eekhoorntest.ionecloud.nl/ione/',
    ajaxUrl: 'https://eekhoorntest.ionecloud.nl/ione/',
    schema: '134953',
    version: '252',
}

export const threedViewerConfig = ENV.isProduction() ? colijnConfigProduction : colijnConfigStaging
